import {PageHeader} from "../../../Components/Public/PageHeader/PageHeader";
import {edBriefDocs, helpTopics} from './GetHelpData';
import {Col, Row} from "react-bootstrap";
import React, {useState} from "react";
import { ReactComponent as Visit } from '../../../Images/public/gethelp/VisitGetHelp.svg';
import { ReactComponent as Email } from '../../../Images/public/gethelp/EmailGetHelp.svg';
import { ReactComponent as Call } from '../../../Images/public/gethelp/CallGetHelp.svg';
import { ReactComponent as MoreHelpCall } from '../../../Images/public/gethelp/MoreHelpCall.svg';
import { ReactComponent as MoreHelpMail } from '../../../Images/public/gethelp/MoreHelpMail.svg';
import Card from "react-bootstrap/Card";
import DocumentCard from "../../../Components/Documents/DocumentCard";
import {setGlobalErrorStatus} from "../../../Components/StatusHandling";
import {ERROR_MESSAGES} from "../../../Utils/constants";
import {useDispatch} from "react-redux";
import { ReactComponent as SupportMail } from '../../../Images/public/aboutpsoppc/supportMail.svg';
import { ReactComponent as SupportContact } from '../../../Images/public/aboutpsoppc/supportContact.svg';
import {PATHS} from "../../../Utils/PagePaths";
import {handleFileDownload} from "../../../Utils/utilityFunctions";
import {ICONS} from "../../../Utils/icons";
import {IconTextButton} from "../../../Components/Button";
import {Link} from "react-router-dom";
import { ReCaptchaWrapper } from "../../../Components/ReCaptcha";

//DOWNLOAD
function GetHelp () {
  const dispatch = useDispatch();
  const supportMailIcon = <SupportMail />;
  const supportContactIcon = <SupportContact/>;
  const [downloadingFiles, setDownloadingFiles] = useState([]);
  const otgPDFGroupId = 193;
  
  const downloadFile = (groupId) => {
    
    //console.log(downloadingFiles);
    if(downloadingFiles.includes(groupId)){
    
    }
    else{
      setDownloadingFiles([...downloadingFiles, groupId]);
      handleFileDownload(
        groupId,
        ()=> {
          //console.log(document.activeElement);
          setGlobalErrorStatus({
            dispatch: dispatch,
            popupData: {
              visible: true,
              title: ERROR_MESSAGES.GENERAL_ERROR.title,
              msg: ERROR_MESSAGES.GENERAL_ERROR.message,
              showContactHelp: true
            },
            redirect: {
              redirect: false,
              redirectFirst: false,
              path: "",
              data: {}
            }
          })
        },
        ()=> {
          setDownloadingFiles(downloadingFiles.filter(f => f == groupId))
        }
      );
    }
    
  }
  
  const errorHandle = function () {
    setGlobalErrorStatus({
      dispatch: dispatch,
      popupData: {
        visible: true,
        title: ERROR_MESSAGES.GENERAL_ERROR.title,
        msg: ERROR_MESSAGES.GENERAL_ERROR.message,
        showContactHelp: true,
      },
      redirect: {
        redirect: false,
        redirectFirst: false,
        path: "",
        data: {},
      },
    });
  };
  
  const renderTitleAndCards = (item, idxT) => {
    return (
      <React.Fragment key={`gh-eb-section-${idxT}`}>
      <h2 className={`my-2 common-formats-header py-4 header3 font-weight-bold`} key={`gh-eb-title-${idxT}`}>{item.title}</h2>
      <div className="doc-card-container two g-3 pb-4">
        {item.cards.map((groupId, idx) => (
            <div
                key={`cf-doc-card-${groupId}-${idx}`}
                className="d-flex"
                // xs={12}
                // sm={12}
                // md={6}
                // lg={6}
                // xl={6}
                // xxl={6}
            >
                <DocumentCard groupId={groupId} errorHandle={errorHandle} />
            </div>
        ))}
      </div>
      </React.Fragment>
    );
  };
  
  return (
    <>
      <ReCaptchaWrapper
        action="get_help_landing"
        title="Get Help"
      >
        
        <PageHeader
          title="Get Help"
          intro="Couldn't find what you were looking for on our site? Here's a few ways to get help."
        />
        <Row className="justify-content-center get-help text-start text-break">
          <Col xxl={8} xl={9} lg={11} md={10} sm={12} className="ps-3 pe-3 ms-3 me-3 p-5 text-start text-break">
            <h2 className={'mb-3 mt-2 header2 font-weight-bold'}>Browse Help Topics</h2>
            <p>Need the information below on the go?</p>
            {/* <IconTextButton
              className="reverse mb-4 ps-0"
              icon={ICONS.downloadoutline}
              onClick={() => downloadFile(otgPDFGroupId)}
              variant="comp-plain"
              content={"AHRQ PSOPPC Technical Assistance Contact List (PDF)"}
            /> */}
            <IconTextButton
              className="reverse mb-4 ps-0"
              icon={ICONS.downloadoutline}
              //onClick={() => downloadFile(otgPDFGroupId)}
              variant="comp-plain"
              content={"AHRQ PSOPPC Technical Assistance Contact List (PDF)"}
              groupId={otgPDFGroupId}
            />
            <h2 className={`my-2 common-formats-header py-4 header3 font-weight-bold`}>Contact PSOPPC</h2>
            <p className="py-1 help-topic-intro">
              If your question relates to <strong>submitting patient safety data</strong> to the PSO Protected Patient Safety Data Center
              (PSOPPC), <strong>managing your PSO account</strong>, generating <strong>reports</strong> from your submitted data, or technical support for
              the system, this is the right section for you. You can find answers about required data fields, file
              formats, user roles, system updates, and technical assistance with AHRQ Common Formats as they relate to
              the PSOPPC system.
            </p>
            <p className={`fw-normal`} >{supportMailIcon} <span className={`ps-xl-2 ps-lg-2 ps-md-2 ps-sm-2 ps-xs-1`}>:</span> <a href="mailto:support@psoppc.org" className={`ps-xl-2 ps-lg-2 ps-md-2 ps-sm-2 ps-xs-1`}>support@psoppc.org</a></p>
            <p className={`fw-normal`}>{supportContactIcon} <span className={`ps-xl-2 ps-lg-2 ps-md-2 ps-sm-2 ps-xs-1`}>:</span> <a href="tel:+18665717712" className={`ps-xl-2 ps-lg-2 ps-md-2 ps-sm-2 ps-xs-1`}>(866) 571-7712</a> (Mon-Fri, 9:00 AM - 5:30 PM ET)</p>
            <Row className="g-3 mt-2 mb-5 text-start text-break">
              {helpTopics.psoppc.map((card, idx) => {
                const visitHref = card?.actions?.visitHref || "#";
                const emailHref = card?.actions?.emailHref || "#";
                const callHref = card?.actions?.callHref || "#";
                return (
                  <Col
                    key={`info-card-${idx}`}
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={12}
                    sm={12}
                    className={`d-flex`}
                  >
                    <Card
                      className="mb-4 mt-2 me-2 w-100 help-topic-cards"
                      // style={{
                      //   border: "1px solid #E0E0E0",
                      //   boxShadow: "1px 2px 4px rgba(0,0,0,0.12)",
                      //   background: "#FFFFFF",
                      // }}
                    >
                      <Card.Header
                        className="border-0"
                        // style={{
                        //   background: "#F4F4F4",
                        //   borderBottom: "1px solid #E0E0E0",
                        // }}
                      >
                        <Row className="justify-content-center">
                          <Col
                            xl={11}
                            lg={11}
                            md={12}
                            sm={12}
                            className="text-start p-0 text-break"
                          >
                            { card.isButton ?
                              <p className='h5 m-0 p-1 px-md-2 get-help-card-header' onClick={() => downloadFile(card.groupId)}> {card.title} </p>
                              :
                              <Link to={visitHref} className='h5 m-0 p-1 px-md-2 get-help-card-header'> {card.title} </Link>
                            }
                          </Col>
                        </Row>
                      </Card.Header>
                      
                      <Card.Body
                        className="ps-3 pe-3 body"
                        // style={{
                        //   background: "#FFFFFF",
                        //   color: "#686E7A",
                        //   display: "flex",
                        //   flexDirection: "column",
                        //   height: "100%",
                        // }}
                      >
                        <Row className="justify-content-center">
                          <Col
                            xl={11}
                            lg={11}
                            md={12}
                            sm={12}
                            className="text-start p-0 text-break"
                          >
                            {Array.isArray(card.body) &&
                              card.body.map((line, i) => (
                                <p key={`body-${idx}-${i}`} className="mb-3 m-0 p-1 px-md-2 get-help-card-body"
                                  // style={{ color: "#32363E" }}
                                >
                                  {line}
                                </p>
                              ))}
                          </Col>
                        </Row>
                        
                        {/*<Row className="text-center mt-auto px-4 pt-4">*/}
                        {/*  <Col>*/}
                        {/*    <a*/}
                        {/*      href={visitHref}*/}
                        {/*      aria-label="Visit"*/}
                        {/*      // style={{ textDecoration: "none", color: "#193F64" }}*/}
                        {/*      target={`_blank`}*/}
                        {/*      rel="noopener noreferrer"*/}
                        {/*      className={`get-more-help-card-footer`}*/}
                        {/*      tabIndex={0}*/}
                        {/*    >*/}
                        {/*      <div*/}
                        {/*        className="d-flex flex-column align-items-center"*/}
                        {/*        style={{ gap: 6 }}*/}
                        {/*      >*/}
                        {/*        <Visit />*/}
                        {/*        <span style={{ fontSize: "18px" }}>Visit</span>*/}
                        {/*      </div>*/}
                        {/*    </a>*/}
                        {/*  </Col>*/}
                        {/*  <Col>*/}
                        {/*    <a*/}
                        {/*      href={"mailto:"+emailHref}*/}
                        {/*      aria-label="Email"*/}
                        {/*      // style={{ textDecoration: "none", color: "#193F64" }}*/}
                        {/*      className={`get-more-help-card-footer`}*/}
                        {/*      tabIndex={0}*/}
                        {/*    >*/}
                        {/*      <div*/}
                        {/*        className="d-flex flex-column align-items-center"*/}
                        {/*        style={{ gap: 6 }}*/}
                        {/*      >*/}
                        {/*        <Email />*/}
                        {/*        <span style={{ fontSize: "18px" }}>Email</span>*/}
                        {/*      </div>*/}
                        {/*    </a>*/}
                        {/*  </Col>*/}
                        {/*  <Col>*/}
                        {/*    <a*/}
                        {/*      href={"tel:"+callHref}*/}
                        {/*      aria-label="Call"*/}
                        {/*      // style={{ textDecoration: "none", color: "#193F64" }}*/}
                        {/*      className={`get-more-help-card-footer`}*/}
                        {/*      tabIndex={0}*/}
                        {/*    >*/}
                        {/*      <div*/}
                        {/*        className="d-flex flex-column align-items-center"*/}
                        {/*        style={{ gap: 6 }}*/}
                        {/*      >*/}
                        {/*        <Call />*/}
                        {/*        <span style={{ fontSize: "18px" }}>Call</span>*/}
                        {/*      </div>*/}
                        {/*    </a>*/}
                        {/*  </Col>*/}
                        {/*</Row>*/}
                      </Card.Body>
                    </Card>
                  </Col>
                );
              })}
            </Row>
            <h2 className={`my-2 common-formats-header py-4 header3 font-weight-bold`}>Contact AHRQ</h2>
            <p className="py-1 help-topic-intro">
              Select this section for information regarding the&nbsp;
              <strong>Patient Safety Organization (PSO) program's general rules and regulations</strong>&nbsp;
              and administrative processes. Topics covered include what a PSO is, the requirements for the&nbsp;
              <strong>PSO Listing Process</strong>, the <strong>Privacy and Confidentiality</strong>&nbsp;
              provisions of the Patient Safety and Quality Improvement Act (PSQIA), and general information about&nbsp;
              <strong>AHRQ Common Formats</strong> and how to provide feedback to AHRQ.
            </p>
            <p className={`fw-normal`} >{supportMailIcon} <span className={`ps-xl-2 ps-lg-2 ps-md-2 ps-sm-2 ps-xs-1`}>:</span> <a href="mailto:pso@ahrq.hhs.gov" className={`ps-xl-2 ps-lg-2 ps-md-2 ps-sm-2 ps-xs-1`}>pso@ahrq.hhs.gov</a></p>
            <p className={`fw-normal`}>{supportContactIcon} <span className={`ps-xl-2 ps-lg-2 ps-md-2 ps-sm-2 ps-xs-1`}>:</span> <a href="tel:+18664033697" className={`ps-xl-2 ps-lg-2 ps-md-2 ps-sm-2 ps-xs-1`}>(866) 403-3697</a></p>
            <Row className="g-3 mt-2 mb-5 text-start text-break">
              {helpTopics.ahrq.map((card, idx) => {
                const visitHref = card?.actions?.visitHref || "#";
                const emailHref = card?.actions?.emailHref || "#";
                const callHref = card?.actions?.callHref || "#";
                return (
                  <Col
                    key={`info-card-${idx}`}
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={12}
                    sm={12}
                    className={`d-flex`}
                  >
                    <Card
                      className="mb-4 mt-2 me-2 w-100 help-topic-cards"
                      // style={{
                      //   border: "1px solid #E0E0E0",
                      //   boxShadow: "1px 2px 4px rgba(0,0,0,0.12)",
                      //   background: "#FFFFFF",
                      // }}
                    >
                      <Card.Header
                        className="border-0"
                        // style={{
                        //   background: "#F4F4F4",
                        //   borderBottom: "1px solid #E0E0E0",
                        // }}
                      >
                        <Row className="justify-content-center">
                          <Col
                            xl={11}
                            lg={11}
                            md={12}
                            sm={12}
                            className="text-start p-0 text-break"
                          >
                            <a href={visitHref} target={`_blank`} rel="noreferrer" className='h5 m-0 p-1 px-md-2 get-help-card-header'> {card.title} </a>
                          </Col>
                        </Row>
                      </Card.Header>
                      
                      <Card.Body
                        className="ps-3 pe-3 body"
                        // style={{
                        //   background: "#FFFFFF",
                        //   color: "#686E7A",
                        //   display: "flex",
                        //   flexDirection: "column",
                        //   height: "100%",
                        // }}
                      >
                        <Row className="justify-content-center">
                          <Col
                            xl={11}
                            lg={11}
                            md={12}
                            sm={12}
                            className="text-start p-0 text-break"
                          >
                            {Array.isArray(card.body) &&
                              card.body.map((line, i) => (
                                <p key={`body-${idx}-${i}`} className="mb-3 m-0 p-1 px-md-2 get-help-card-body"
                                  // style={{ color: "#32363E" }}
                                >
                                  {line}
                                </p>
                              ))}
                          </Col>
                        </Row>
                        
                        {/*<Row className="text-center mt-auto px-4 pt-4">*/}
                        {/*  <Col>*/}
                        {/*    <a*/}
                        {/*      href={visitHref}*/}
                        {/*      aria-label="Visit"*/}
                        {/*      // style={{ textDecoration: "none", color: "#193F64" }}*/}
                        {/*      target={`_blank`}*/}
                        {/*      rel="noopener noreferrer"*/}
                        {/*      className={`get-more-help-card-footer`}*/}
                        {/*      tabIndex={0}*/}
                        {/*    >*/}
                        {/*      <div*/}
                        {/*        className="d-flex flex-column align-items-center"*/}
                        {/*        style={{ gap: 6 }}*/}
                        {/*      >*/}
                        {/*        <Visit />*/}
                        {/*        <span style={{ fontSize: "18px" }}>Visit</span>*/}
                        {/*      </div>*/}
                        {/*    </a>*/}
                        {/*  </Col>*/}
                        {/*  <Col>*/}
                        {/*    <a*/}
                        {/*      href={"mailto:"+emailHref}*/}
                        {/*      aria-label="Email"*/}
                        {/*      // style={{ textDecoration: "none", color: "#193F64" }}*/}
                        {/*      className={`get-more-help-card-footer`}*/}
                        {/*      tabIndex={0}*/}
                        {/*    >*/}
                        {/*      <div*/}
                        {/*        className="d-flex flex-column align-items-center"*/}
                        {/*        style={{ gap: 6 }}*/}
                        {/*      >*/}
                        {/*        <Email />*/}
                        {/*        <span style={{ fontSize: "18px" }}>Email</span>*/}
                        {/*      </div>*/}
                        {/*    </a>*/}
                        {/*  </Col>*/}
                        {/*  <Col>*/}
                        {/*    <a*/}
                        {/*      href={"tel:"+callHref}*/}
                        {/*      aria-label="Call"*/}
                        {/*      // style={{ textDecoration: "none", color: "#193F64" }}*/}
                        {/*      className={`get-more-help-card-footer`}*/}
                        {/*      tabIndex={0}*/}
                        {/*    >*/}
                        {/*      <div*/}
                        {/*        className="d-flex flex-column align-items-center"*/}
                        {/*        style={{ gap: 6 }}*/}
                        {/*      >*/}
                        {/*        <Call />*/}
                        {/*        <span style={{ fontSize: "18px" }}>Call</span>*/}
                        {/*      </div>*/}
                        {/*    </a>*/}
                        {/*  </Col>*/}
                        {/*</Row>*/}
                      </Card.Body>
                    </Card>
                  </Col>
                );
              })}
            </Row>
            {/* <h2 className={'mb-3 mt-2 header2 font-weight-bold pb-4'}>Educational Briefs</h2>
            {edBriefDocs.map((item, idx) =>
              renderTitleAndCards(item, idx)
            )} */}
            {/*<h2 className={'mb-3 mt-5 header2 font-weight-bold text-center pb-4'}>Need more help? Get in touch 2 ways</h2>*/}
            {/*<Row className="g-3 pb-4">*/}
            {/*  <Col*/}
            {/*    xs={12}*/}
            {/*    sm={12}*/}
            {/*    md={6}*/}
            {/*    lg={6}*/}
            {/*    xl={6}*/}
            {/*    xxl={6}*/}
            {/*  >*/}
            {/*    <Card tabIndex={0} className="document-card">*/}
            {/*      <Card.Body>*/}
            {/*        <Card.Text>*/}
            {/*          <p className={`mt-2`}>*/}
            {/*            <MoreHelpMail/>*/}
            {/*          </p>*/}
            {/*          <p className="my-3 get-more-help-card-body"*/}
            {/*             // style={{ color: "#193F64" }}*/}
            {/*          >*/}
            {/*            Email*/}
            {/*          </p>*/}
            {/*          <p className={`body get-more-help-card-info`}*/}
            {/*             // style={{color: "#32363E"}}*/}
            {/*          >support@psoppc.org</p>*/}
            {/*        </Card.Text>*/}
            {/*      </Card.Body>*/}
            {/*    </Card>*/}
            {/*  </Col>*/}
            {/*  <Col*/}
            {/*    xs={12}*/}
            {/*    sm={12}*/}
            {/*    md={6}*/}
            {/*    lg={6}*/}
            {/*    xl={6}*/}
            {/*    xxl={6}*/}
            {/*  >*/}
            {/*    <Card tabIndex={0} className="document-card">*/}
            {/*      <Card.Body>*/}
            {/*        <Card.Text>*/}
            {/*          <p className={`mt-2`}>*/}
            {/*            <MoreHelpCall/>*/}
            {/*          </p>*/}
            {/*          <p className="my-3 get-more-help-card-body"*/}
            {/*             // style={{ color: "#193F64" }}*/}
            {/*          >*/}
            {/*            Call*/}
            {/*          </p>*/}
            {/*          <p className={`body get-more-help-card-info`}*/}
            {/*             // style={{color: "#32363E"}}*/}
            {/*          >866-571-7712</p>*/}
            {/*        </Card.Text>*/}
            {/*      </Card.Body>*/}
            {/*    </Card>*/}
            {/*  </Col>*/}
            {/*</Row>*/}
          </Col>
        </Row>
      </ReCaptchaWrapper>
      
    </>
  )
}

export default GetHelp;